var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAttachment2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "#539ADA",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1019 18.8633L17.1019 8.8291",
    stroke: "#4347A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5322 16.4238L17.1022 18.8638L14.6722 16.4238",
    stroke: "#4347A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.963 12.7734H21.7405C23.4364 12.7734 24.8105 14.1476 24.8105 15.8443V19.9143C24.8105 21.6059 23.4397 22.9768 21.748 22.9768H12.4647C10.7689 22.9768 9.39388 21.6018 9.39388 19.9059L9.39388 15.8351C9.39388 14.1443 10.7655 12.7734 12.4564 12.7734H13.2414",
    stroke: "#4347A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAttachment2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-attachment2.d1ef4c3e.svg";
export { ForwardRef as ReactComponent };